export default __webpack_public_path__ + "static/media/open-pod-image4.9103ee8f.png";